import React from "react";

function initiales(user) {
  return `${user.name?.[0] || ""}${user.lastName?.[0] || ""}`.toUpperCase();
}

const MAX_DOSSIERS_VISIBLES = 3;

// Colonne "Charge par collaborateur".
function ChargeCollaborateurCard({ user, dossiers }) {
  const visibles = dossiers.slice(0, MAX_DOSSIERS_VISIBLES);
  const masques = dossiers.slice(MAX_DOSSIERS_VISIBLES);

  return (
    <div className="flex-none w-[232px] bg-[#fff6ee] border border-gray-200 rounded-xl flex flex-col">
      <div className="flex items-center gap-2 px-3 py-2.5 border-b border-gray-200">
        <span className="w-7 h-7 rounded-full bg-[#f7e9ee] text-[#6e1a36] grid place-items-center text-[10px] font-bold flex-none">
          {initiales(user)}
        </span>
        <span className="text-xs font-semibold text-gray-900 whitespace-nowrap overflow-hidden text-ellipsis">
          {user.name} {user.lastName?.[0] ? `${user.lastName[0]}.` : ""}
        </span>
        <span className="ml-auto inline-grid place-items-center min-w-[20px] h-5 px-1.5 rounded-full bg-white border border-gray-200 text-gray-600 text-xs font-bold">
          {dossiers.length}
        </span>
      </div>
      <div className="flex flex-col gap-0.5 px-2.5 py-1.5 text-xs">
        {visibles.map((d, index) => (
          <span
            key={index}
            className={d.overdue ? "text-red-600" : "text-gray-600"}
          >
            {d.clientNom || "—"}
          </span>
        ))}
        {masques.length > 0 && (
          <span
            className="text-gray-400 font-semibold"
            title={masques.map((d) => d.clientNom || "—").join(", ")}
          >
            +{masques.length} autre{masques.length > 1 ? "s" : ""}
          </span>
        )}
      </div>
    </div>
  );
}

export default ChargeCollaborateurCard;
